import { useRef, useState, useEffect } from "react";
import * as Icons from "../assets/SVGs/index";
import Button from "../components/basicComponents/button";
import TextInput from "../components/basicComponents/text-input";
import Container from "../components/basicComponents/container";
import ToggleSwitch from "../components/basicComponents/switch-box";
import Select from "../components/basicComponents/select";
import Grid from "../components/grid";
import { useDispatch, useSelector } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";
import { userEdit, userRemove } from "../state-management/actions/user-actions";
import { userRegister } from "../state-management/actions/auth-actions";
import {
  setRowStatus,
  setUsersData,
} from "../state-management/actions/global-state-actions";
import {
  setAlert,
  setAlertSeverity,
  setAlertContext,
} from "../state-management/actions/alerts-actions";
import { UserProps } from "../types/public";
import { RemovePermission } from "../utils/remove-permission";
import {
  addUserToDepartment,
  removeGrouing,
} from "../state-management/actions/grouping-actions";

const initialNewUserData: UserProps = {
  _id: "",
  username: "",
  firstname: "",
  lastname: "",
  phone: "",
  personal_code: "",
  email: "",
  is_active: true,
  role_id: "",
  main_department: "",
};

export default function AddUsers() {
  const dispatch = useDispatch();
  const [flag, setFlag] = useState<boolean>(false);
  const [newUserData, setNewUserData] = useState<UserProps>(initialNewUserData);
  const {
    usersData,
    rolesData,
    rowStatus,
    groupingData,
    articlesData,
    projectsData,
    newsData,
    departmentsData,
    faqData,
  } = useSelector(selectGlobalState);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const selectOption = rolesData
    ?.filter((item: any) => item.name !== "owner")
    .map((item: any) => ({
      label: item.name,
      value: item._id,
    }));
  const selectDepartment = [{ label: "هیچکدام", value: null }].concat(
    departmentsData?.map((item: any) => ({
      label: item.name,
      value: item._id,
    })) || []
  );

  useEffect(() => {
    dispatch(setRowStatus("clear id", false));
    setNewUserData(initialNewUserData);
  }, [dispatch]);

  useEffect(() => {
    const groupData = groupingData
      .map((item: any) => ({
        ...item,
        department_id: Array.from(
          new Set(item.department_id?.filter((id: any) => id !== null) || [])
        ),
      }))
      .filter((item: any) => item.department_id.length > 1);
    const oneDep = usersData.filter(
      (user: any) =>
        !groupData.some(
          (groupingUser: any) => groupingUser.user_id === user._id
        )
    );

    const notAdded = oneDep.filter(
      (user: any) =>
        !groupingData.some((group: any) => group.user_id === user._id)
    );
    // setNewUsers(notAdded);

    const user = notAdded.find(
      (item: any) =>
        item?.main_department !== null && item?.main_department !== undefined
    );
    if (user && user.main_department.length > 0) {
      const addNewUser = async () => {
        await addUserToDepartment({
          department_id: user.main_department,
          user_id: user._id,
          description: "test",
        })(dispatch);
      };
      addNewUser();
    }
  }, [flag]);

  const handleSubmit = async () => {
    try {
      const { _id, ...cleanData } = newUserData;
      console.log(_id);
      const responseRegister = await userRegister(cleanData)(dispatch);
      if (responseRegister) {
        const updateData = [
          ...usersData,
          { ...cleanData, _id: responseRegister.data.NewItem._id },
        ];
        dispatch(setUsersData(updateData));
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext(" کاربر مربوطه اضافه شد"));
      }
      setFlag((prev: any) => !prev);
      setNewUserData(initialNewUserData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = async () => {
    try {
      const { _id, role_id, ...cleanData } = newUserData;
      const role = rolesData.find((role: any) => role._id === role_id).name;
      let editData;
      if (role !== "owner") {
        editData = {
          role_id,
          ...cleanData,
          main_department:
            cleanData.main_department == "هیچکدام"
              ? null
              : cleanData.main_department,
        };
      } else {
        editData = {
          ...cleanData,
          main_department:
            cleanData.main_department == "هیچکدام"
              ? null
              : cleanData.main_department,
        };
      }
      console.log(editData);
      const response = await userEdit(_id, editData)(dispatch);
      if (response.data && rowStatus?.id) {
        dispatch(
          setUsersData(
            usersData.map((user: any) =>
              user._id === rowStatus.id ? { ...user, ...newUserData } : user
            )
          )
        );
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext(" کاربر مربوطه ویرایش شد"));
      }
      setNewUserData(initialNewUserData);
      dispatch(setRowStatus("clear id", false));
    } catch (error) {
      console.log(error);
    }
  };

  const handleSetEditData = async (clear: boolean, id: any) => {
    const setData = usersData.find((item: any) => item._id === id);
    if (!clear && setData) {
      setNewUserData(setData);
    }
    if (clear) {
      setNewUserData(initialNewUserData);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      console.log();
      const userExists = RemovePermission(id, [
        groupingData,
        articlesData,
        projectsData,
        newsData,
        departmentsData,
        faqData,
      ]);
      if (!userExists) {
        const geoupId = groupingData.find(
          (item: any) => item.user_id === id
        )._id;
        const response = await userRemove(id)(dispatch);
        await removeGrouing(geoupId)(dispatch);
        if (response.data) {
          const updateData = usersData.filter((item: any) => item._id !== id);
          dispatch(setAlert(true));
          dispatch(setAlertSeverity("success"));
          dispatch(setAlertContext(" کاربر مربوطه حذف شد"));
          dispatch(setUsersData(updateData));
        }
      } else {
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("warning"));
        dispatch(setAlertContext("کاربر مربوطه دارای وابستگی است"));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setNewUserData({ ...newUserData, [name]: value });
  };

  return (
    <div className="flex flex-col items-center w-full">
      <Container header="ثبت کاربر">
        <div className="flex flex-col md:gap-y-5 gap-y-2 w-full">
          <div
            className="md:grid md:grid-cols-3 md:grid-rows-2 flex flex-col gap-2"
            style={{ direction: "rtl" }}
          >
            <TextInput
              name="firstname"
              label="نام"
              placeholder="نام"
              RightIcon={<Icons.UserIcon />}
              value={newUserData.firstname}
              onChange={handleInputChange}
            />
            <TextInput
              name="lastname"
              label="نام خانوادگی"
              placeholder="نام خانوادگی"
              RightIcon={<Icons.UserIcon />}
              value={newUserData.lastname}
              onChange={handleInputChange}
            />
            <TextInput
              name="username"
              label="نام کاربری"
              placeholder="نام کاربری"
              RightIcon={<Icons.UserIcon />}
              value={newUserData.username}
              onChange={handleInputChange}
            />
            <TextInput
              name="personal_code"
              label="شماره پرسنلی"
              placeholder="شماره پرسنلی"
              RightIcon={<Icons.IdIcon />}
              value={newUserData.personal_code}
              onChange={handleInputChange}
            />
            <TextInput
              name="phone"
              label="شماره تلفن"
              placeholder="شماره تلفن"
              RightIcon={<Icons.PhoneIcon />}
              value={newUserData.phone}
              onChange={handleInputChange}
            />
            <TextInput
              name="email"
              placeholder="ایمیل"
              RightIcon={<Icons.MailIcon />}
              value={newUserData.email}
              onChange={handleInputChange}
            />
            <Select
              name="role"
              placeholder="یک گزینه را انتخاب کنید"
              className="w-full"
              value={newUserData.role_id}
              onChange={(e) => {
                setNewUserData({
                  ...newUserData,
                  role_id: e.target.value,
                });
              }}
              options={selectOption}
            />
            <Select
              name="main_department"
              placeholder="یک گزینه را انتخاب کنید"
              className="w-full"
              value={newUserData.main_department}
              onChange={(e) => {
                setNewUserData({
                  ...newUserData,
                  main_department: e.target.value,
                });
              }}
              options={selectDepartment}
            />
            <div className="p-4">
              <ToggleSwitch
                label=" کاربر فعال"
                checked={newUserData.is_active}
                onChange={() =>
                  setNewUserData((prev: any) => ({
                    ...prev,
                    is_active: !prev.is_active,
                  }))
                }
              />
            </div>
          </div>
          <div className="flex justify-between items-center w-full">
            <div className="flex justify-between gap-x-12 items-center md:flex-row flex-col"></div>
            <Button
              ref={buttonRef}
              variant={!rowStatus?.status ? "success" : "edit"}
              title={!rowStatus?.status ? "ثبت" : "ویرایش"}
              paddingx="20px"
              paddingy="6px"
              onClick={!rowStatus?.status ? handleSubmit : handleEdit}
            />
          </div>
        </div>
      </Container>
      <Container header=" مدیریت کاربران">
        <Grid
          height={800}
          columns={[
            {
              headerName: " نام و نام خانوداگی",
              valueGetter: (params: any) =>
                `${params.data.firstname} ${params.data.lastname}`,
              pinned: "right",
            },
            { headerName: "نام کاربری", field: "username" },
            {
              headerName: "نقش",
              valueGetter: (params: any) =>
                selectOption.find(
                  (item: any) => item.value === params.data.role_id
                )?.label || "",
            },
            { headerName: "شماره تماس", field: "phone" },
            { headerName: "ایمیل", field: "email" },
            { headerName: "وضعیت", field: "is_active" },
          ]}
          userData={usersData}
          pageSize={50}
          pagination={true}
          editBtn={true}
          deleteBtn={true}
          editable={false}
          handleDelete={handleDelete}
          handleSetData={handleSetEditData}
          btnHeader="عملیات"
        />
      </Container>
    </div>
  );
}
